/*函数防抖*/
const debounce = (fn, interval) => {
  var timer
  var gapTime = interval || 300 //间隔时间，如果interval不传，则默认1000ms
  return function () {
    clearTimeout(timer)
    var context = this
    var args = arguments //保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function () {
      fn.call(context, args)
    }, gapTime)
  }
}

module.exports = {
  debounce,
}



// WEBPACK FOOTER //
// ./src/utils/tools.js